import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import RosterService from '../../services/roster-service';
import { isStudioSource } from '../../utils/source';

const Person = ( props ) => {
    const { personId, auth, source } = props;

    const [ person, setPerson ] = useState( null );

    useEffect( () => {
        if ( !personId ) {
            return;
        }
        const loadPerson = async () => {
            try {
                const authState = isStudioSource( source ) ? auth.state.original : auth.state;
                const roster = RosterService( authState );
                const personResponse = await roster.getPerson( personId );
                setPerson( personResponse );
            } catch ( error ) {
                console.error( 'Error fetching person', error.status );
                setPerson( null );
            }
        };
        loadPerson();
    }, [ personId, source, auth?.state?.original?.claims?.company_id, auth?.state?.claims?.company_id ] );

    return (
        person ?
            <span>{ person.givenName } { person.surname }</span>
            :
            <span style={ { display: 'flex' } } > <Spin size="small" data-testid="person-spin" /> </span>
    );
};

export default Person;